import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectVertiLoginState } from '../selectors';
import { LoginResponse } from '@models/swagger';

export const getData = createSelector(selectVertiLoginState, (state: State) => state.data);

export const getError = createSelector(selectVertiLoginState, (state: State) => state.error);

export const getLoading = createSelector(selectVertiLoginState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: LoginResponse | null) => T) =>
  createSelector(selectVertiLoginState, (state: State) => fn(state.data));
